export default {"src":"/_next/static/media/4x4_for_dark_themes.3342ab76.svg","height":256,"width":256,"blurWidth":0,"blurHeight":0};